import { createGlobalStyle, styled } from 'styled-components'

// print isolation + page setup
// - on screen the daily plan is hidden
// - on print the whole app is made invisible and only the daily plan is revealed
//   (the "visibility" trick keeps descendants visible without needing to know
//    the app shell's class names, so no existing component has to be touched)
export const GlobalPrintStyles = createGlobalStyle`
    @page { size: A4 portrait; margin: 12mm; }

    .calendar-print-root { display: none; }

    @media print {
        html, body { background: #fff !important; }

        body * { visibility: hidden !important; }

        .calendar-print-root,
        .calendar-print-root * { visibility: visible !important; }

        .calendar-print-root {
            display: block !important;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }
    }
`

export const Root = styled.div`
    color: #000;
    background: #fff;
`

export const Header = styled.div`
    margin-bottom: 16px;
`

export const Brand = styled.div`
    font-size: 20px;
    font-weight: 700;
`

export const Title = styled.div`
    font-size: 16px;
    margin-top: 4px;
`

export const Sub = styled.div`
    font-size: 12px;
    margin-top: 2px;
`

export const Section = styled.section`
    margin-top: 18px;
    break-inside: avoid;
    page-break-inside: avoid;
`

export const SectionTitle = styled.div`
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px;
    margin-top: 4px;
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;

    thead { display: table-header-group; }

    th, td {
        border: none;
        border-bottom: 1px solid #ccc;
        padding: 5px 6px;
        text-align: left;
        vertical-align: top;
    }

    thead th {
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
    }

    th { font-weight: 700; }
`
